import { createFileRoute, Navigate } from "@tanstack/react-router"
import { MyRoster } from "@/components/crewroster/MyRoster"
import { useCurrentCrewMember } from "@/hooks/useCurrentCrewMember"
import { z } from "zod"

const rosterSearchSchema = z.object({
  tab: z.enum(["calendar", "list"]).optional().default("calendar"),
})

export const Route = createFileRoute("/_auth/roster/$crewId")({
  component: RouteComponent,
  validateSearch: rosterSearchSchema,
})

function RouteComponent() {
  const { crewId } = Route.useParams()
  const { tab } = Route.useSearch()
  const { data: currentUser } = useCurrentCrewMember()

  // A crew member excluded from scheduling has no roster of their own — send
  // them home. Admins viewing other crew's rosters are unaffected.
  if (currentUser?.id === crewId && currentUser?.includeInSchedule === false) {
    return <Navigate to="/home" />
  }

  return <MyRoster crewId={crewId} tab={tab} />
}
